import cn from 'classnames';
import React, {useEffect} from 'react';

import {SHOP_PAGE_HEADER_TITLE} from '@/consts/localization/localizationKeys';
import useDocumentTitle from '@/hooks/useDocumentTitle';
import amplitudeShopPageTracking from '@/services/analytics/amplitude/amplitudeShopPageTracking';
import googleAnalyticsService from '@/services/analytics/ga/googleAnalyticsService';
import {HOME_PAGE_NAVIGATION_SOURCE_TYPES} from '@/services/homePageNavigationService';
import {getLocalizedStrings} from '@/services/localization/localizationService';
import DynamicPage from '@/views/DynamicPage/DynamicPage';
import HomePageLayout from '@/views/Home/HomePageLayout';
import {WARNING_BANNER_SOURCE_TYPES, WarningBanners, WarningBannersTop} from '@/views/WarningBanners';

import HomePageTopNavigation from '../HomePageTopNavigation/HomePageTopNavigation';
import styles from './ShopPage.module.scss';

const ShopPage = () => {
    const localizedStrings = getLocalizedStrings();

    useDocumentTitle(localizedStrings[SHOP_PAGE_HEADER_TITLE]);

    useEffect(() => {
        amplitudeShopPageTracking.trackShopPageScreen();
        googleAnalyticsService.trackShopScreenView();
    }, []);

    return (
        <HomePageLayout className={cn('bg-primary-dark-5 md:pb-2', styles.ShopPage)}>
            <WarningBannersTop source={WARNING_BANNER_SOURCE_TYPES.SHOP} className='ml:pl-[var(--sidebar-width)]' />
            <HomePageTopNavigation
                title={localizedStrings[SHOP_PAGE_HEADER_TITLE]}
                source={HOME_PAGE_NAVIGATION_SOURCE_TYPES.SHOP}
                profileControlsClassName='md:bg-romance'
            />
            <DynamicPage />
            <WarningBanners source={WARNING_BANNER_SOURCE_TYPES.SHOP} contentClassName='md:-mb-2 md:mt-4 lg:mt-2' />
        </HomePageLayout>
    );
};

export default ShopPage;
